import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { useEffect, useState } from "react";

export default function Tracer() {
  const [tracerInitialized, setTracerInitialized] = useState(false);

  useEffect(() => {
    try {
      if (tracerInitialized) {
        return;
      }

      if (!import.meta.env.VITE_APP_DD_TOKEN) {
        console.info("Datadog RUM token not found, skipping initialization");
        return;
      }

      const logSampleRate = +(import.meta.env.VITE_APP_DD_LOG_SAMPLE_RATE ?? "10"); // TODO FIXME remove default
      const sessionReplaySampleRate = +(import.meta.env.VITE_APP_DD_SESSION_REPLAY_SAMPLE_RATE ?? "0"); // TODO FIXME remove default
      const rumSampleRate = +(import.meta.env.VITE_APP_DD_RUM_SAMPLE_RATE ?? "10"); // TODO FIXME remove default
      const traceSampleRate = +(import.meta.env.VITE_APP_DD_TRACE_SAMPLE_RATE ?? "10"); // TODO FIXME remove default

      console.info("Logs sample rate: ", logSampleRate);
      console.info("TOKEN: ", import.meta.env.VITE_APP_DD_TOKEN);
      console.info("RUM sample rate: ", rumSampleRate);
      console.info("Session replay rate: ", sessionReplaySampleRate);

      datadogRum.init({
        allowedTracingUrls: [
          (url) => {
            const regex = /^https:\/\/.*truetour\.app\/api.*$/;
            return regex.test(url);
          },
        ],
        applicationId: "22e3ebb5-4427-4b8c-b254-dbec97d8264c", // TODO FIXME should be env var
        beforeSend: (event) => {
          if (event.type === "error" && event.error && typeof event.error.message === "string") {
            if (event.error.message.includes("Login required")) {
              console.log('Datadog RUM: Suppressing "Login required" error.');
              return false; // Prevents the event from being sent to Datadog
            }
          } else if (event.type === "error" && typeof event.message === "string") {
            if (event.message.includes("Login required")) {
              console.log('Datadog RUM: Suppressing "Login required" error.');
              return false; // Prevents the event from being sent to Datadog
            }
          }
          return true; // Send all other events
        },
        clientToken: import.meta.env.VITE_APP_DD_TOKEN,
        defaultPrivacyLevel: "mask-user-input",
        env: import.meta.env.VITE_APP_ENV ?? "dev", // TODO FIXME remove default
        service: "ttx-frontend",
        sessionReplaySampleRate: sessionReplaySampleRate,
        sessionSampleRate: rumSampleRate,
        site: "datadoghq.com",
        trackLongTasks: true,
        trackResources: true,
        traceSampleRate: traceSampleRate,
        trackUserInteractions: true,
        version: import.meta.env.VITE_APP_VERSION,
      });

      console.info("Datadog RUM initialized");

      datadogLogs.init({
        clientToken: import.meta.env.VITE_APP_DD_TOKEN,
        env: import.meta.env.VITE_APP_ENV ?? "dev", // TODO FIXME remove default
        forwardErrorsToLogs: true,
        service: "ttx-frontend",
        sessionSampleRate: logSampleRate,
        silentMultipleInit: true,
        site: "datadoghq.com",
        version: import.meta.env.VITE_APP_VERSION,
      });

      console.info("Datadog Logs initialized");

      setTracerInitialized(true);
    } catch (err) {
      console.log(err);
    }
  }, []);
  return <></>;
}
